// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import WarrantyDetails from './WarrantyDetail';

import { IRoute } from '../';

const Routes: IRoute[] = [
    {
        crumbText: 'warranty_detail',
        component: WarrantyDetails,
        exact: true,
        path: '/device/warrantyDetail',
    },
];

export default Routes;
